import React from 'react';
import { useStoreState } from 'easy-peasy';

import EmailCampaignForm from './EmailCampaignForm';

const CreateEmailCampaignTemplate = ({ history }) => {
  const { userId } = useStoreState(state => state.auth);
  return (
    <EmailCampaignForm history={history} isUpdate={false} userId={userId} />
  );
};

export default CreateEmailCampaignTemplate;
